import { render, staticRenderFns } from "./form-editor.pug?vue&type=template&id=76138cdd&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./form-editor.scss?vue&type=style&index=0&id=76138cdd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76138cdd",
  null
  
)

export default component.exports